// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6d56708f","83":"f6f13bb2","186":"51670779","223":"5b772b0d","362":"86b3a90d","473":"37e5a55b","595":"32771c1b","598":"016fbe61","620":"fadb2045","673":"42f455b3","857":"a3353edd","977":"cf97f77e"}[chunkId] + ".chunk.js";
};